import { render, staticRenderFns } from "./voc.vue?vue&type=template&id=202664a6&scoped=true&"
import script from "./voc.vue?vue&type=script&lang=js&"
export * from "./voc.vue?vue&type=script&lang=js&"
import style0 from "./voc.vue?vue&type=style&index=0&id=202664a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202664a6",
  null
  
)

export default component.exports